<div class="card mt-3">
  <div class="card-body">
    <h3 class="mb-4">{{ 'MENU.DASHBOARD.edit_cities' | translate }}</h3>

    <!-- مؤشر التحميل -->
    <div *ngIf="isLoading" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">{{ 'MENU.DASHBOARD.loading' | translate }}</p>
    </div>

    <form 
      *ngIf="!isLoading"
      #jobTitleForm="ngForm" 
      (ngSubmit)="onSubmit()" 
      enctype="multipart/form-data"
      novalidate
    >
      <div class="row">

        <!-- Nationality -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label required-field">
              {{ 'MENU.DASHBOARD.nationality' | translate }}
              <span class="text-danger">*</span>
            </label>
            <select
              class="form-control"
              [class.is-invalid]="!formData.country_id && jobTitleForm.submitted"
              [(ngModel)]="formData.country_id"
              name="country_id"
              required
            >
              <option value="" disabled selected>
                {{ 'MENU.DASHBOARD.select_countries' | translate }}
              </option>
              <option *ngFor="let country of countries" [value]="country.id">
                {{  country.name }}
              </option>
            </select>
            <div *ngIf="!formData.country_id && jobTitleForm.submitted" class="invalid-feedback d-block">
              {{ 'MENU.DASHBOARD.nationality_required' | translate }}
            </div>
          </div>
        </div>

        <!-- City Name (English) -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label">
              {{ 'MENU.DASHBOARD.cities_name_en' | translate }}
              <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              [class.is-invalid]="nameEn.invalid && (nameEn.touched || jobTitleForm.submitted)"
              placeholder="{{ 'MENU.DASHBOARD.enter_cities_name_en' | translate }}"
              [(ngModel)]="formData.name_en"
              name="name_en"
              required
              minlength="2"
              #nameEn="ngModel"
            />
            <div *ngIf="nameEn.invalid && (nameEn.touched || jobTitleForm.submitted)" class="invalid-feedback d-block">
              <span *ngIf="nameEn.errors?.['required']">
                {{ 'MENU.DASHBOARD.cities_name_en_required' | translate }}
              </span>
              <span *ngIf="nameEn.errors?.['minlength']">
                {{ 'MENU.DASHBOARD.min_length_2' | translate }}
              </span>
            </div>
          </div>
        </div>

        <!-- City Name (Arabic) -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label">
              {{ 'MENU.DASHBOARD.cities_name_ar' | translate }}
              <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              [class.is-invalid]="nameAr.invalid && (nameAr.touched || jobTitleForm.submitted)"
              placeholder="{{ 'MENU.DASHBOARD.enter_cities_name_ar' | translate }}"
              [(ngModel)]="formData.name_ar"
              name="name_ar"
              required
              minlength="2"
              #nameAr="ngModel"
            />
            <div *ngIf="nameAr.invalid && (nameAr.touched || jobTitleForm.submitted)" class="invalid-feedback d-block">
              <span *ngIf="nameAr.errors?.['required']">
                {{ 'MENU.DASHBOARD.cities_name_ar_required' | translate }}
              </span>
              <span *ngIf="nameAr.errors?.['minlength']">
                {{ 'MENU.DASHBOARD.min_length_2' | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Submit + Cancel -->
      <div class="text-start mt-3">
        <button
          type="submit"
          class="btn btn-suc px-3 "
          [disabled]="isSubmitting"
        >
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
          {{ 'MENU.DASHBOARD.edit_cities' | translate }}
        </button>

        <button
          type="button"
          class="btn btn-secondary ms-2 px-3 mx-2"
          (click)="cancel()"
          [disabled]="isSubmitting"
        >
          {{ 'MENU.DASHBOARD.cancel' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>